import { render, staticRenderFns } from "./grantProject.vue?vue&type=template&id=0de87abc&scoped=true&"
import script from "./grantProject.vue?vue&type=script&lang=js&"
export * from "./grantProject.vue?vue&type=script&lang=js&"
import style0 from "./grantProject.vue?vue&type=style&index=0&id=0de87abc&prod&lang=css&"
import style1 from "./grantProject.vue?vue&type=style&index=1&id=0de87abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de87abc",
  null
  
)

export default component.exports